import {StationDataItemInfos} from "./StationDataItemInfos"

export class POIItemInfo {

	constructor() {

		this.address = null;
		this.hotPointID = null;
		this.lonlat = null;
		this.name = null;
		this.phone = null;
		this.poiType = null;
		this.stationItems = null;
		this.url = null;
	}


	static GetPOIItem(jsonObj) {
		let curItem=null;
		if(jsonObj==null)return curItem;

		curItem=new POIItemInfo();

		curItem.address =jsonObj.address;
		curItem.hotPointID=jsonObj.hotPointID;
		curItem.lonlat=jsonObj.lonlat;
		curItem.name=jsonObj.name;
		curItem.phone=jsonObj.phone;
		curItem.poiType=jsonObj.poiType;
		curItem.url=jsonObj.url;
		
		let curstationData=jsonObj.stationData;
		if(curstationData !=null)
		{	
			curItem.stationItems = StationDataItemInfos.GetStationDataItems(curstationData);
		}

		return curItem;
	}

}//end POIItemInfo

